import React from 'react';
import appStoreBadge from './assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
import googlePlayBadge from './assets/images/google-play-badge.png';
import {
  SWIMBOOKER_APP_STORE_URL,
  SWIMBOOKER_GOOGLE_PLAY_URL,
} from '../../AppConstants';

function AppStoreBadges({ height = 44, className = '' }) {
  const badgeStyle = { height, width: 'auto' };

  return (
    <div className={`row-center gap-05r ${className}`}>
      <a href={SWIMBOOKER_APP_STORE_URL}>
        <img
          src={appStoreBadge}
          alt='Download on the App Store'
          width={120}
          height={40}
          style={badgeStyle}
        />
      </a>
      <a href={SWIMBOOKER_GOOGLE_PLAY_URL}>
        <img
          src={googlePlayBadge}
          alt='Get it on Google Play'
          width={564}
          height={168}
          style={badgeStyle}
        />
      </a>
    </div>
  );
}

export default AppStoreBadges;
